// This dapp targets Base mainnet only. Addresses are hardcoded so the UI
// works regardless of REACT_APP_* env vars being picked up at build time.
export const baseConfig = {
  chainId: '0x2105',
  chainName: 'Base Mainnet',
  rpcUrls: ['https://mainnet.base.org'],
  blockExplorerUrls: ['https://basescan.org/'],
  nativeCurrency: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
  },
  contractAddress: '0x8f4c93ff18a9f26eeb5596b0bfa315d11038a228',
  stakingContractAddress: '0x6C2075da840c8574B9DFf96f9D1E890Ac37F58bC',
  uniswapPoolAddress: '0x46bcd3059aef1302cd51eb57205e2e548f3b1c5a',
  usdcAddress: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
};

export const localConfig = {
  chainId: '0x7a69', chainName: 'Local Anvil', rpcUrls: ['http://127.0.0.1:8545'],
  blockExplorerUrls: [], nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 }
};
export const preferredNetwork = process.env.REACT_APP_BONDS_NETWORK === 'local' ? localConfig : baseConfig;
export const networks = process.env.REACT_APP_BONDS_NETWORK === 'local' ? { base: baseConfig, local: localConfig } : { base: baseConfig };
